/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CampaignsInputs */

const en_nav_campaigns = /** @type {(inputs: Nav_CampaignsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaigns`)
};

/**
* | output |
* | --- |
* | "Campaigns" |
*
* @param {Nav_CampaignsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_campaigns = /** @type {((inputs?: Nav_CampaignsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CampaignsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_campaigns(inputs)
});